import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { thousandize } from "../../../../util/formatting";
import styles from "./ResultsTeaser.module.scss";
import LinkButton from "../../../shared/components/EffektButton/LinkButton";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
import { publicTrpcFor } from "../../../../lib/trpc/client";
export const ResultsTeaser: React.FC<{
  sumSubtitle?: string;
  donorsSubtitle?: string;
  seeMoreButton?: NavLink;
  locale: string;
}> = t0 => {
  const $ = _c(29);
  const {
    sumSubtitle,
    donorsSubtitle,
    seeMoreButton,
    locale
  } = t0;
  const [data, setData] = useState(null);
  let t1;
  let t2;
  if ($[0] !== locale) {
    t1 = () => {
      publicTrpcFor(locale).site.resultsHeadline.query().then(setData).catch(console.error);
    };
    t2 = [locale];
    $[0] = locale;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== data?.totalDonationsToRecommendedOrgs || $[4] !== locale) {
    t3 = thousandize(Math.round(parseFloat(String(data?.totalDonationsToRecommendedOrgs ?? "0"))), locale);
    $[3] = data?.totalDonationsToRecommendedOrgs;
    $[4] = locale;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <span className={styles.headlineNumber} data-cy="results-teaser-sum">{t3}{" "}kr</span>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== sumSubtitle) {
    t5 = <span>{sumSubtitle}</span>;
    $[8] = sumSubtitle;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = Number(data?.numberOfDonors ?? 0);
  let t8;
  if ($[13] !== locale || $[14] !== t7) {
    t8 = thousandize(t7, locale);
    $[13] = locale;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <span className={styles.headlineNumber} data-cy="results-teaser-donors">{t8}</span>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== donorsSubtitle) {
    t10 = <span>{donorsSubtitle}</span>;
    $[18] = donorsSubtitle;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = <div>{t9}{t10}</div>;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== seeMoreButton) {
    t12 = seeMoreButton && seeMoreButton.slug && <div><LinkButton url={"/" + seeMoreButton.slug} title={seeMoreButton.title || "See more"} /></div>;
    $[23] = seeMoreButton;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12 || $[27] !== t6) {
    t13 = <div className={styles.container}><div className={styles.grid}>{t6}{t11}{t12}</div></div>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t6;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};